import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper, useTheme } from '@mui/material';
import { Home, MoneyOff, AttachMoney, Category, Assessment } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  HOME_ROUTE_PATH,
  EXPENSES_ROUTE_PATH,
  INCOMES_ROUTE_PATH,
  CATEGORIES_ROUTE_PATH,
  MONTHLY_REPORTS_ROUTE_PATH,
} from '../../utils/constants/AppConstants';

interface BottomNavComponentProps {
  hidden?: boolean;
}

const BottomNavComponent: React.FC<BottomNavComponentProps> = ({ hidden = false }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    { label: 'Home', icon: <Home />, path: HOME_ROUTE_PATH },
    { label: 'Expenses', icon: <MoneyOff />, path: EXPENSES_ROUTE_PATH },
    { label: 'Income', icon: <AttachMoney />, path: INCOMES_ROUTE_PATH },
    { label: 'Categories', icon: <Category />, path: CATEGORIES_ROUTE_PATH },
    { label: 'Reports', icon: <Assessment />, path: MONTHLY_REPORTS_ROUTE_PATH },
  ];

  const currentIndex = Math.max(items.findIndex(i => i.path === location.pathname), 0);

  const handleChange = (_: any, newValue: number) => {
    const item = items[newValue];
    if (item) navigate(item.path);
  };

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 12,
        left: 12,
        right: 12,
        borderRadius: theme.radii?.medium ?? 10,
        display: { xs: hidden ? 'none' : 'block', md: 'none' },
        zIndex: theme.zIndex.appBar,
      }}
    >
      <BottomNavigation showLabels value={currentIndex} onChange={handleChange}>
        {items.map((it) => (
          <BottomNavigationAction key={it.path} label={it.label} icon={it.icon} />
        ))}
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNavComponent;
